import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from "../../login/shared/auth.service";
import { Role } from "../Shared/role";
import { RoleService } from "../Shared/role.service";

import { CommonmastersService } from "../../commonmasters/commonmasters.service";


@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css']
})
export class RoleComponent implements OnInit {

  addForm: FormGroup;
  btnvisibility: boolean = true;

  RoleNo: number;
  RoleList: any[] = [];
  DocumentList: any[] = [];
  ErrorText : string ;

  constructor(private formBuilder: FormBuilder,private route: ActivatedRoute,
    private router: Router,private authService: AuthService,
    private roleService: RoleService) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.RoleNo = +  params['Id'];
    });

    if (Number.isNaN(this.RoleNo)) {
      this.addForm = this.formBuilder.group({
        frmId: [0],
        frmRoleName:['', Validators.required],
        frmCode:[],
        frmRemarks: [],
        frmActive: [true],
        frmFlag: [1],
      });
      // this.AddButtonText = "Save";
    }
    else {
      
      // this.AddButtonText = "Edit & Save";
      this.GetRolesById();
    }

  }

  onSubmit() {

    if (this.addForm.value.frmRoleName != '') {
      this.roleService.IUDRole(this.addForm).toPromise()
        .then(data => {

        this.router.navigate(['/rolelist']);
        })
      }
  }

  GetRolesById() {
    this.roleService.FetchRoleById(this.RoleNo).subscribe(data => {

      this.addForm = this.formBuilder.group({
        frmId: [data.Id],
        frmRoleName:[data.Code],
        frmCode:[data.Name],
        frmRemarks: [data.Remarks],
        frmActive: [true],
        frmFlag: [2],
      });
    })
  }

}
